import { useQuery } from '@tanstack/react-query';
import { fetch_between_dates } from '../services/api';
import type { AdmKitchMenuDetailsView } from '../types';

// vw_adm_kitch_menu_details görünümünden tarih aralığı bazlı menü satırları.
// Anahtarlar AdmKitchMenuList/Edit sayfalarındaki invalidation ile uyumlu tutuldu.
export const kitchenMenuRangeQueryKey = (start: string, end: string) =>
  ['kitchenMenuRange', start, end] as const;

export function useKitchenMenuRange(start: string, end: string, enabled = true) {
  return useQuery<AdmKitchMenuDetailsView[], Error>({
    queryKey: kitchenMenuRangeQueryKey(start, end),
    queryFn: () => fetch_between_dates('vw_adm_kitch_menu_details', 'menu_date', start, end),
    enabled,
    // Haftalık planlayıcıda kaydedilmemiş düzenlemeler pencere odağıyla ezilmesin
    refetchOnWindowFocus: false,
  });
}

// Ana sayfa kartı: bugünün menüsü (15 dk önbellek yeterli).
export function useKitchenMenuForDate(date: string) {
  return useQuery<AdmKitchMenuDetailsView[], Error>({
    queryKey: ['kitchenMenuByDate', date],
    queryFn: () => fetch_between_dates('vw_adm_kitch_menu_details', 'menu_date', date, date),
    staleTime: 15 * 60 * 1000,
  });
}
